<template>
  <div class="screen-horizontal-container" @dblclick="hangleFullPage">
    <div
      class="header"
      :style="{ height: '100px' }"
      :class="{ 'header-cn': $i18n.locale === 'zh', 'header-en': $i18n.locale === 'en' }"
    >
      <div class="logo-container" style="display: flex;">
        <el-image class="logo" :src="require('@/assets/PhiniaLogo.png')" fit="contain" />
      </div>
      <div class="language-container" style="display: flex;">
        <language />
      </div>
    </div>
    <div class="body">
      <div class="column-left">
        <section class="module">
          <h4 class="title">{{ $t('bghn.dlcc') }}</h4>
          <div class="content chart-content row-flex">
            <PieChart
              style="width:60%"
              :data="Number(powerGeneration.totalSolar.cvalue[0])"
              :unit="powerGeneration.totalSolar.cvalue[1]"
            />
            <div class="flex-grow column-flex space-around text-info">
              <p class="yellow">
                <b>{{ $t('bghn.brfdl') }}</b>
                <br>
                <span>
                  {{ powerGeneration.daySolar.cvalue[0] }}
                  {{ powerGeneration.daySolar.cvalue[1] }}
                </span>
              </p>
              <p class="yellow">
                <b>{{ $t('bghn.brzfzydl') }}</b>
                <br>
                <span>
                  {{ powerGeneration.daySelfUse.cvalue[0] }}
                  {{ powerGeneration.daySelfUse.cvalue[1] }}
                </span>
              </p>
              <p class="blue">
                <b>{{ $t('bghn.byfdl') }}</b>
                <br>
                <span>
                  {{ powerGeneration.monthSolar.cvalue[0] }}
                  {{ powerGeneration.monthSolar.cvalue[1] }}
                </span>
              </p>
            </div>
          </div>
        </section>
        <section class="module">
          <h4 class="title">{{ $t('bghn.jnjp') }}</h4>
          <div class="content row-flex space-around align-center">
            <div class="text-center info">
              <el-image :src="require('@/assets/bigscreen/co.png')" />
              <p>{{ $t('bghn.co2jp') }}</p>
              <p style="margin-top: 10px;">
                {{ emissionReduction.co2.cvalue[0] }}
                {{ emissionReduction.co2.cvalue[1] }}
              </p>
            </div>
            <div class="text-center info">
              <el-image :src="require('@/assets/bigscreen/tree.png')" />
              <p>{{ $t('bghn.dxlz') }}</p>
              <p style="margin-top: 10px;">
                {{ emissionReduction.trees.cvalue[0] }}
                {{ $t('bghn.k') }}
              </p>
            </div>
          </div>
        </section>
      </div>

      <div class="column-middle">
        <div class="chart-row">
          <h4 class="title">{{ $t('bghn.drdlqx') }}</h4>
          <div ref="dailyChart" class="chart-container" />
        </div>
        <div class="chart-row">
          <h4 class="title">{{ $t('bghn.dydlqx') }}</h4>
          <div ref="monthlyChart" class="chart-container" />
        </div>
        <div class="chart-row">
          <h4 class="title">{{ $t('bghn.drsy') }}</h4>
          <div ref="dailyRevenueChart" class="chart-container" />
        </div>
        <div class="chart-row">
          <h4 class="title">{{ $t('bghn.dysy') }}</h4>
          <div ref="revenueChart" class="chart-container" />
        </div>
      </div>

      <div class="column-right">
        <section class="module">
          <h4 class="title">
            {{ $t('bghn.dzxx') }}
            <span>{{ time }}</span>
          </h4>
          <div class="content column-flex">
            <h4>{{ stationInfo.stationName }}</h4>
            <div class="column-flex flex-grow space-around info">
              <p>
                <b>{{ $t('bghn.dzzt') }}</b>
                <span>{{ getStatusText(stationInfo.status) }}</span>
              </p>
              <p>
                <b>{{ $t('bghn.dzlx') }}</b>
                <span>{{ $t('bghn.gsydz') }}</span>
              </p>
              <p>
                <b>{{ $t('bghn.bwsj') }}</b>
                <span>{{ stationInfo.gridTime }}</span>
              </p>
              <p>
                <b>{{ $t('bghn.dzdz') }}</b>
                <span>{{ $i18n.locale == 'zh' ? stationInfo.addressCn : stationInfo.addressEn }}</span>
              </p>
            </div>
          </div>
        </section>
        <section class="module">
          <h4 class="title">{{ $t('bghn.dxfd') }}</h4>
          <div class="content column-flex">
            <div class="column-flex flex-grow space-around info">
              <p>
                <b>{{ $t('bghn.zjrl') }}</b>
                <span>
                  {{ equivalentGeneration.capacity.cvalue[0] }}
                  {{ equivalentGeneration.capacity.cvalue[1] }}
                </span>
              </p>
              <p>
                <b>{{ $t('bghn.rdxfdxs') }}</b>
                <span>{{ equivalentGeneration.dayFull }} h</span>
              </p>
              <p>
                <b>{{ $t('bghn.ydxfdxs') }}</b>
                <span>{{ equivalentGeneration.monthFull }} h</span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts"
import screenfull from "screenfull/dist/screenfull.js"
import language from "../../layout/header/Language.vue"
import PieChart from "@views/Charts/PieChart2.vue"
import dayjs from "dayjs"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
dayjs.extend(isSameOrBefore)
export default {
  name: "ScreenHorizontal",
  components: {
    language,
    PieChart
  },
  props: {
    tvdata: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

      /** 电量产出模块 */
      powerGeneration: {
        totalSolar: { orivalue: 0, cvalue: [0, 'kWh'] }, // 总发电量
        daySolar: { orivalue: 0, cvalue: [0, ''] }, // 日发电量
        daySelfUse: { orivalue: 0, cvalue: [0, ''] }, // 日自发自用电量
        monthSolar: { orivalue: 0, cvalue: [0, ''] } // 月发电量
      },

      /** 节能减排模块 */
      emissionReduction: {
        co2: { orivalue: 0, cvalue: [0, ''] }, // CO₂减排
        trees: { orivalue: 0, cvalue: [0, ''] } // 等效绿植
      },

      /** 当日电量曲线图表 */
      dailyChartData: {
        timeData: [], // 时间轴（0:00~23:00）
        valueData: [] // 电量值
      },

      /** 当月电量柱状图表 */
      monthlyChartData: {
        days: [], // 日期轴（MM月dd日）
        values: [] // 电量值
      },

      /** 当日收益图表 */
      dailyRevenueValue: 0,

      /** 当月收益柱状图表 */
      revenueChartData: {
        days: [], // 日期轴（MM月dd日）
        revenues: [] // 收益值
      },

      /** 电站信息模块 */
      stationInfo: {
        stationName: '', // 电站名称
        status: '', // 电站状态
        stationCategory: '', // 电站类型
        gridTime: '', // 并网时间
        addressCn: '', // 电站地址（中文）
        addressEn: '' // 电站地址（英文）
      },

      /** 等效发电模块 */
      equivalentGeneration: {
        capacity: { orivalue: 0, cvalue: [0, 'kWp'] }, // 装机容量
        dayFull: 0, // 日等效发电小时
        monthFull: 0 // 月等效发电小时
      },

      time: "", // 当前时间
      timer: null, // 时间定时器

      dailyChart: null, // 当日电量曲线图表实例
      monthlyChart: null, // 当月电量曲线图表实例
      dailyRevenueChart: null, // 当日收益环形图表实例
      revenueChart: null // 当月收益柱状图表实例
    }
  },
  mounted () {
    this.initData()
  },
  beforeDestroy () {
    this.clearTimerAndChart()
  },
  methods: {

    /** 初始化数据 */
    initData () {
      this.timer = setInterval(() => {
        this.time = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }, 1000)
      this.refreshData()
    },

    /** 刷新数据 */
    refreshData () {
      this.initModuleData().setLargeScreenData()
      this.$nextTick(() => {
        this.initDailyChart()
        this.initMonthlyChart()
        this.initDailyRevenueChart()
        this.initRevenueChart()
      })
    },

    /** 清除定时器和图表实例 */
    clearTimerAndChart () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.dailyChart) {
        this.dailyChart.dispose()
      }
      if (this.monthlyChart) {
        this.monthlyChart.dispose()
      }
      if (this.dailyRevenueChart) {
        this.dailyRevenueChart.dispose()
      }
      if (this.revenueChart) {
        this.revenueChart.dispose()
      }
    },

    /**
     * 获取电站状态文本（支持状态码和中文字段双向映射）
     * @param {string} val 状态码('0'-'3')或中文字段
     * @returns {string} 当前语言的状态文本
     */
    getStatusText (val) {
      if (!val) return '--'
      const codeMap = {
        '0': 'bghn.zx',
        '1': 'bghn.bfzx',
        '2': 'bghn.lx',
        '3': 'bghn.bj'
      }
      const textToCode = {
        '在线': '0',
        '部分在线': '1',
        '离线': '2',
        '报警': '3'
      }
      const key = codeMap[val] || codeMap[textToCode[val]]
      if (key) return this.$t(key)
      return val
    },

    /** 全屏切换 */
    hangleFullPage () {
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    },

    /** 初始化各模块数据（从 tvdata 填充或使用默认值） */
    initModuleData () {
      const response = this.tvdata || {}

      /** 设置电量产出模块数据 */
      const setPowerGeneration = () => {
        const { electricityOutput } = response
        this.powerGeneration.totalSolar = electricityOutput.totalGeneratedEnergy
        this.powerGeneration.daySolar = electricityOutput.currentDayGeneratedEnergy
        this.powerGeneration.monthSolar = electricityOutput.currentMonthGeneratedEnergy
        this.powerGeneration.daySelfUse = electricityOutput.currentDayGeneratedEnergyBySelfUse
      }

      /** 设置节能减排模块数据 */
      const setEmissionReduction = () => {
        const { emissionReduction } = response
        this.emissionReduction.co2 = emissionReduction.carbonEmission
        this.emissionReduction.trees = emissionReduction.equivalentTreePlantingVolume
      }

      /** 设置电站信息模块数据 */
      const setStationInformation = () => {
        const { stationInformation } = response
        this.stationInfo.stationName = stationInformation.stationName
        this.stationInfo.status = stationInformation.status
        this.stationInfo.gridTime = dayjs(stationInformation.gridTime).format('YYYY-MM-DD HH:mm:ss')
        this.stationInfo.addressCn = stationInformation.stationAddressCn
        this.stationInfo.addressEn = stationInformation.stationAddressEn
      }

      /** 设置等效发电模块数据 */
      const setEquivalentGeneration = () => {
        const { equivalentPowerGeneration } = response
        this.equivalentGeneration.capacity = equivalentPowerGeneration.installedCapacity
        this.equivalentGeneration.dayFull = equivalentPowerGeneration.dayEquivalentPowerGenerationHours
        this.equivalentGeneration.monthFull = equivalentPowerGeneration.monthEquivalentPowerGenerationHours
      }

      /** 设置当日电量曲线图表数据 */
      const setDailyChartData = () => {
        const { currentDayGeneratedEnergy } = response
        this.dailyChartData.valueData = []
        this.dailyChartData.timeData = []
        if (currentDayGeneratedEnergy.length > 0) {
          currentDayGeneratedEnergy.map(item => {
            this.dailyChartData.timeData.push(dayjs(item.time).format('HH:mm'))
            this.dailyChartData.valueData.push(item.value)
          })
        }
        fillDailyChartTo24Clock()
      }

      /** 填充当日电量曲线图表数据至24点 */
      const fillDailyChartTo24Clock = () => {
        const { currentDayGeneratedEnergy } = response
        const startTime = dayjs(currentDayGeneratedEnergy[currentDayGeneratedEnergy.length - 1].time)
        const endTime = dayjs(dayjs(startTime).add(1, 'day').hour(0).minute(0).second(0))
        for (let timePoint = startTime; timePoint.isSameOrBefore(endTime); timePoint = dayjs(timePoint).add(5, 'minute')) {
          this.dailyChartData.timeData.push(dayjs(timePoint).format('HH:mm'))
          this.dailyChartData.valueData.push(0)
        }
      }

      /** 设置当月电量柱状图表数据 */
      const setMonthlyChartData = () => {
        const { currentMonthGeneratedEnergy } = response
        this.monthlyChartData.days = []
        this.monthlyChartData.values = []
        if (currentMonthGeneratedEnergy.length > 0) {
          currentMonthGeneratedEnergy.map(item => {
            this.monthlyChartData.days.push(dayjs(item.time).format('YYYY-MM-DD'))
            this.monthlyChartData.values.push(item.total)
          })
        }
      }

      /** 设置当日收益模块数据 */
      const setDailyRevenueValue = () => {
        const { currentDayInCome } = response
        this.dailyRevenueValue = currentDayInCome
      }

      /** 设置当月收益柱状图表数据 */
      const setRevenueChartData = () => {
        const { currentMonthInCome } = response
        this.revenueChartData.days = []
        this.revenueChartData.revenues = []
        if (currentMonthInCome.length > 0) {
          currentMonthInCome.map(item => {
            this.revenueChartData.days.push(dayjs(item.time).format('YYYY-MM-DD'))
            this.revenueChartData.revenues.push(item.total)
          })
        }
      }

      /** 设置大屏数据 */
      const setLargeScreenData = () => {
        /** 设置电量产出模块数据 */
        setPowerGeneration()

        /** 设置节能减排模块数据 */
        setEmissionReduction()

        /** 设置电站信息模块数据 */
        setStationInformation()

        /** 设置等效发电模块数据 */
        setEquivalentGeneration()

        /** 设置当日电量曲线图表数据 */
        setDailyChartData()

        /** 设置当月电量柱状图表数据 */
        setMonthlyChartData()

        /** 设置当日收益模块数据 */
        setDailyRevenueValue()

        /** 设置当月收益柱状图表数据 */
        setRevenueChartData()
      }
      return {
        setLargeScreenData
      }
    },

    /** 初始化当日电量曲线（ECharts 折线图） */
    initDailyChart () {
      this.dailyChart = echarts.init(this.$refs.dailyChart)
      this.dailyChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: { color: '#222' }
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: { color: '#fff' },
          axisLine: { lineStyle: { color: '#1a3a5c' }},
          axisTick: { show: false },
          data: this.dailyChartData.timeData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            formatter: '{value} kWh'
          },
          splitLine: { lineStyle: { color: '#1a3a5c', type: 'dashed' }}
        },
        series: [{
          type: 'line',
          smooth: true,
          showSymbol: false,
          lineStyle: { color: '#06cdf8', width: 2 },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(6, 205, 248, 0.3)' },
              { offset: 1, color: 'rgba(6, 205, 248, 0.02)' }
            ])
          },
          data: this.dailyChartData.valueData
        }]
      })
    },

    /** 初始化当月电量柱状图表（ECharts 柱状图） */
    initMonthlyChart () {
      this.monthlyChart = echarts.init(this.$refs.monthlyChart)
      this.monthlyChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: { color: '#222' }
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: { color: '#fff' },
          data: this.monthlyChartData.days
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            formatter: '{value} kWh'
          },
          splitLine: { lineStyle: { color: '#1a3a5c', type: 'dashed' }}
        },
        series: [{
          type: 'bar',
          itemStyle: { color: '#06cdf8' },
          data: this.monthlyChartData.values
        }]
      })
    },

    /** 初始化当日收益环形图（ECharts 饼图-环形图） */
    initDailyRevenueChart () {
      this.dailyRevenueChart = echarts.init(this.$refs.dailyRevenueChart)
      this.dailyRevenueChart.setOption({
        title: {
          text: '{b|' + this.$t('bghn.drsy') + '}\n{c|¥' + this.dailyRevenueValue.toFixed(2) + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              b: { fontSize: 12, color: '#f2f2f2', lineHeight: 15, align: 'center' },
              c: { fontSize: 14, fontWeight: 'bold', color: '#06cdf8', lineHeight: 26, align: 'center' }
            }
          }
        },
        series: [{
          type: 'pie',
          radius: ['70%', '100%'],
          avoidLabelOverlap: false,
          silent: true,
          label: { show: false },
          data: [
            {
              value: 75,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#06cdf8' },
                  { offset: 1, color: '#4C8FF0' }
                ])
              }
            },
            {
              value: 25,
              itemStyle: { color: '#173164' }
            }
          ]
        }]
      })
    },

    /** 初始化当月收益柱状图（ECharts 柱状图） */
    initRevenueChart () {
      this.revenueChart = echarts.init(this.$refs.revenueChart)
      this.revenueChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: { color: '#222' }
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: { color: '#fff' },
          axisLine: { lineStyle: { color: '#1a3a5c' }},
          axisTick: { show: false },
          data: this.revenueChartData.days
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            formatter: '{value} ¥'
          },
          splitLine: { lineStyle: { color: '#1a3a5c', type: 'dashed' }}
        },
        series: [{
          type: 'bar',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#4C8FF0' },
              { offset: 1, color: '#2a5fa0' }
            ])
          },
          data: this.revenueChartData.revenues
        }]
      })
    }
  }
}
</script>

<style scoped>
.screen-horizontal-container {
    height: 100vh;
    width: 100vw;
    padding: 0;
    background-color: #0C1E39;
    box-sizing: border-box;

    .header {
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        background-position: center center;
        background-repeat: no-repeat;
        justify-content: space-between;

        .logo-container{
            width: 25%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .language-container {
            width: 25%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .logo {
            height: 30%;
            width: 50%;
            margin-right: 50px;
        }

        .language {
            height: 30%;
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .language::v-deep .el-dropdown-link {
            font-size: large;
        }
    }

    .header-cn {
        background-image: url('../../assets/bigscreen/head-mbg1.png');
    }

    .header-en {
        background-image: url('../../assets/bigscreen/head-mbg2.png');
    }

    .body {
        height: calc(100% - 100px);
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(4, 1fr);
        gap: 15px;
        padding: 0 5px 8px;
        box-sizing: border-box;

        .column-left {
            height: 100%;
            display: grid;
            grid-column:1;
            grid-row: 1 / 5;
            grid-template-rows: 1fr 1fr;
            gap: 15px;

            .module {
                background: url('../../assets/bigscreen/bg2.png') center center no-repeat;
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .title {
                    color: #f2f2f2;
                    font-size:large;
                    position: relative;
                    padding-left: 15px;
                    margin: 0;

                    span {
                        margin-left: 20px;
                        font-size: normal;
                        color: #598DDB;
                        position: absolute;
                        right: 10px;
                    }
                }

                .title::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    background-color: #06CDF8;
                    border-radius: 4px;
                    position: absolute;
                    left: 0px;
                    top: 2px;
                    bottom: 2px;
                }

                .content {
                    flex: 1;
                    width: 100%;
                    padding-top: 10px;
                    box-sizing: border-box;

                    h4 {
                        color: #e8e8e8;
                        font-size: x-large;
                        line-height: 40px;
                        margin: 0;
                    }
                }

                .text-info {
                    color: #e8e8e8;
                    padding: 50px 0;
                    box-sizing: border-box;
                    font-size: 16px;
                    min-height: 150px;

                    b {
                        font-weight: normal;
                    }

                    .blue {
                        background: url('../../assets/bigscreen/blue.png') center center no-repeat;
                        background-size: 100% 100%;
                        padding-left: 20px;
                        padding-bottom: 10px;

                        span {
                            line-height: 30px;
                        }
                    }

                    .yellow {
                        background: url('../../assets/bigscreen/yellow.png') center center no-repeat;
                        background-size: 100% 100%;
                        padding-left: 20px;
                        padding-bottom: 10px;

                        span {
                            line-height: 30px;
                        }
                    }
                }

                .info {
                    color: #e8e8e8;
                    font-size: large;
                }
            }
        }

        .column-middle {
            height: 100%;
            display: grid;
            grid-column: 2 / 4;
            grid-row: 1 / span 4;
            grid-template-rows: repeat(4,1fr);
            gap: 15px;

            .chart-row {
                background: url('../../assets/bigscreen/bg2.png') center center no-repeat;
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .title {
                    color: #f2f2f2;
                    font-size: large;
                    position: relative;
                    padding-left: 15px;
                    margin: 0 0 5px 0;
                }

                .title::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    background-color: #06CDF8;
                    height: 16px;
                    border-radius: 4px;
                    position: absolute;
                    left: 0px;
                    top: calc(50% - 8px);
                }

                .chart-container {
                    flex: 1;
                    width: 100%;
                }
            }
        }

        .column-right {
            height: 100%;
            display: grid;
            grid-row: 1 / 5;
            grid-column: 4;
            grid-template-rows: 1fr 1fr;
            gap: 15px;

            .module {
                background: url('../../assets/bigscreen/bg2.png') center center no-repeat;
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .title {
                    color: #f2f2f2;
                    font-size: large;
                    position: relative;
                    padding-left: 15px;
                    margin: 0;

                    span {
                        margin-left: 20px;
                        font-size: large;
                        color: #598DDB;
                        position: absolute;
                        right: 10px;
                    }
                }

                .title::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    background-color: #06CDF8;
                    border-radius: 4px;
                    position: absolute;
                    left: 0px;
                    top: 2px;
                    bottom: 2px;
                }

                .content {
                    flex: 1;
                    width: 100%;
                    padding-top: 10px;
                    box-sizing: border-box;

                    h4 {
                        color: #e8e8e8;
                        font-size: large;
                        line-height: 40px;
                        margin: 0;
                    }
                }

                .info {
                    color: #e8e8e8;
                    font-size: large;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-evenly;

                    b {
                        font-weight: normal;
                    }

                    span {
                        display: inline-block;
                        margin-left: 20px;
                        color: #598DDB;
                    }
                }
            }
        }
    }
}
</style>
